import { FC } from 'react';
import ReportDetails from '../../component/reportDetails/reportDetails';
import { createInterventionReportConfig } from '../../component/reportDetails/interventionReportConfig';
import { InterventionReportDetailsProps } from './interventionReports.type';
import { ReportDetailsConfig } from '../../component/reportDetails/reportDetails.types';

export const InterventionReportDetails: FC<InterventionReportDetailsProps> = (
  props,
) => {
  const config: ReportDetailsConfig = createInterventionReportConfig(
    props.interventionReport,
  );

  return (
    <ReportDetails
      config={config}
      onClose={props.onClose}
      onReviewAndSign={props.onReviewAndSign}
    />
  );
};
